import { render } from "./Infant.vue?vue&type=template&id=3e2e3077&scoped=true"
import script from "./Infant.vue?vue&type=script&lang=js"
export * from "./Infant.vue?vue&type=script&lang=js"

import "./Infant.vue?vue&type=style&index=0&id=3e2e3077&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2e3077"]])

export default __exports__